<template>
  <div
    class="mb-2 d-flex item"
    v-bind:class="{current: isCurrent}"
    v-bind:style="styles"
    @click="onSelect"
  >
    <div class="flex-grow-1">
            <span class="item-title">
                {{ sendList.name | uppercase }}
            </span>
    </div>
    <div class="flex-shrink-0">
      <div class="d-inline-block">
        <div class="dropdown">
          <button class="btn btn-purple btn-sm dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-paper-plane fa-fw pr-1"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
            <button class="dropdown-item" type="button" @click.stop="onSendQuickMessage">
              <i class="far fa-comment-alt mr-3"></i>Sms
            </button>
            <button class="dropdown-item" type="button" @click.stop="showEmailBulkMessageForm">
              <i class="fas fa-at  mr-3"></i>Mail
            </button>
          </div>
        </div>
      </div>
      <button class="btn btn-sm btn-purple" @click.stop="onEdit">
        <i class="fas fa-edit"></i>
      </button>
      <button class="btn btn-sm btn-danger" @click.stop="onDelete">
        <i class="far fa-trash-alt"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sendList: Object,
    isCurrent: Boolean,
  },

  data() {
    return {};
  },

  computed: {
    /**
     * @return {Object|null}
     */
    brand() {
      return _.get(this.sendList, 'brand', null);
    },

    /**
     * @return {Object}
     */
    styles() {
      const {
        'brand.item.background.color': backgroundColor
      } = _.get(this.brand, 'styles') || {};

      return _.pickBy({backgroundColor});
    },

    /**
     * @returns {Boolean}
     */
    canSendMessage() {
      return Boolean(_.get(this.sendList, 'canSendMessage'));
    },
  },

  methods: {
    /**
     * @event select
     */
    onSelect() {
      this.$emit('select', this.sendList);
    },

    /**
     * @event delete
     */
    onDelete() {
      this.$emit('delete', this.sendList);
    },

    /**
     * @event edit
     */
    onEdit() {
      this.$emit('edit', this.sendList);
    },

    /**
     * @event quick-message
     */
    onSendQuickMessage() {
      this.$emit('quick-message', this.sendList);
    },

    /**
     * @event send-email_bulk-message
     */
    showEmailBulkMessageForm() {
      this.$emit('email-message', this.sendList);
    }
  },
}
</script>
